<template>
    <nav class="pagination is-centered is-rounded py-4 px-2" role="navigation" aria-label="pagination">
        <a v-if="!onlyDirectional" class="pagination-previous" @click.prevent="changePage(1)" :disabled="pagination.current_page <= 1">First Page</a>
        <a class="pagination-previous" @click.prevent="changePage(pagination.current_page - 1)" :disabled="pagination.current_page <= 1">Previous</a>
        <a class="pagination-next" @click.prevent="changePage(pagination.current_page + 1)" :disabled="pagination.current_page >= pagination.last_page">Next Page</a>
        <a v-if="!onlyDirectional" class="pagination-next" @click.prevent="changePage(pagination.last_page)" :disabled="pagination.current_page >= pagination.last_page">Last Page</a>

        <ul v-if="!onlyDirectional" class="pagination-list m-0">
            <li v-for="(page,index) in pages" v-bind:key="index">
                <a class="pagination-link" :class="isCurrentPage(page) ? 'is-current' : ''"
                    @click.prevent="changePage(page)">{{
                    page }}</a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: 'pagination',

        props: {
            pagination: {type: Object},
            offset: {type: Number},
            onlyDirectional: {
                default: false
            }
        },

        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },

            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                this.pagination.current_page = page;
                this.$emit('paginate');
            }
        },

        computed: {
            pages() {
                let pages = [];
                let from = this.pagination.current_page - Math.floor(this.offset / 2);

                if (from < 1) {
                    from = 1;
                }

                let to = from + this.offset - 1;
                if (to > this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                while (from <= to) {
                    pages.push(from);
                    from++;
                }

                return pages;
            }
        }
    }

</script>

<style scoped>
    li {
        list-style-type: none;
    }

    .pagination-previous,
    .pagination-next,
    .pagination-link,
    .pagination-ellipsis {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .pagination-previous,
    .pagination-next,
    .pagination-link,
    .pagination-ellipsis {
        -moz-appearance: none;
        -webkit-appearance: none;
        align-items: center;
        border: 1px solid transparent;
        border-radius: 4px;
        box-shadow: none;
        display: inline-flex;
        font-size: 1rem;
        height: 2.25em;
        justify-content: flex-start;
        line-height: 1.5;
        padding-bottom: calc(0.375em - 1px);
        padding-left: calc(0.625em - 1px);
        padding-right: calc(0.625em - 1px);
        padding-top: calc(0.375em - 1px);
        position: relative;
        vertical-align: top;
    }

    .pagination-previous:focus,
    .pagination-next:focus,
    .pagination-link:focus,
    .pagination-ellipsis:focus,
    .is-focused.pagination-previous,
    .is-focused.pagination-next,
    .is-focused.pagination-link,
    .is-focused.pagination-ellipsis,
    .pagination-previous:active,
    .pagination-next:active,
    .pagination-link:active,
    .pagination-ellipsis:active,
    .is-active.pagination-previous,
    .is-active.pagination-next,
    .is-active.pagination-link,
    .is-active.pagination-ellipsis {
        outline: none;
    }

    .pagination-previous[disabled],
    .pagination-next[disabled],
    .pagination-link[disabled],
    .pagination-ellipsis[disabled],
    fieldset[disabled] .pagination-previous,
    fieldset[disabled] .pagination-next,
    fieldset[disabled] .pagination-link,
    fieldset[disabled] .pagination-ellipsis {
        cursor: not-allowed;
    }


    .pagination {
        font-size: 1rem;
        margin: -0.25rem;
    }

    .pagination.is-small {
        font-size: 0.75rem;
    }

    .pagination.is-medium {
        font-size: 1.25rem;
    }

    .pagination.is-large {
        font-size: 1.5rem;
    }

    .pagination.is-rounded .pagination-previous,
    .pagination.is-rounded .pagination-next {
        padding-left: 1em;
        padding-right: 1em;
        border-radius: 290486px;
    }

    .pagination.is-rounded .pagination-link {
        border-radius: 290486px;
    }

    .pagination,
    .pagination-list {
        align-items: center;
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .pagination-previous,
    .pagination-next,
    .pagination-link,
    .pagination-ellipsis {
        font-size: 1em;
        justify-content: center;
        margin: 0.25rem;
        padding-left: 0.5em;
        padding-right: 0.5em;
        text-align: center;
    }

    .pagination-previous,
    .pagination-next,
    .pagination-link {
        border-color: #dbdbdb;
        color: #363636;
        min-width: 2.25em;
    }

    .pagination-previous:hover,
    .pagination-next:hover,
    .pagination-link:hover {
        border-color: #b5b5b5;
        color: #363636;
    }

    .pagination-previous:focus,
    .pagination-next:focus,
    .pagination-link:focus {
        border-color: #3273dc;
    }

    .pagination-previous:active,
    .pagination-next:active,
    .pagination-link:active {
        box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.2);
    }

    .pagination-previous[disabled],
    .pagination-next[disabled],
    .pagination-link[disabled] {
        background-color: #dbdbdb;
        border-color: #dbdbdb;
        box-shadow: none;
        color: #7a7a7a;
        opacity: 0.5;
    }

    .pagination-previous,
    .pagination-next {
        padding-left: 0.75em;
        padding-right: 0.75em;
        white-space: nowrap;
    }

    .pagination-link.is-current {
        background-color: #3273dc;
        border-color: #3273dc;
        color: #fff;
    }

    .pagination-ellipsis {
        color: #b5b5b5;
        pointer-events: none;
    }

    .pagination-list {
        flex-wrap: wrap;
    }

    @media screen and (max-width: 768px) {
        .pagination {
            flex-wrap: wrap;
        }

        .pagination-previous,
        .pagination-next {
            flex-grow: 1;
            flex-shrink: 1;
        }

        .pagination-list li {
            flex-grow: 1;
            flex-shrink: 1;
        }
    }

    @media screen and (min-width: 769px),
    print {
        .pagination-list {
            flex-grow: 1;
            flex-shrink: 1;
            justify-content: flex-start;
            order: 1;
        }

        .pagination-previous {
            order: 2;
        }

        .pagination-next {
            order: 3;
        }

        .pagination {
            justify-content: space-between;
        }

        .pagination.is-centered .pagination-previous {
            order: 1;
        }

        .pagination.is-centered .pagination-list {
            justify-content: center;
            order: 2;
        }

        .pagination.is-centered .pagination-next {
            order: 3;
        }

        .pagination.is-right .pagination-previous {
            order: 1;
        }

        .pagination.is-right .pagination-next {
            order: 2;
        }

        .pagination.is-right .pagination-list {
            justify-content: flex-end;
            order: 3;
        }
    }

</style>
